// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-collapse__header {
  display: inline-flex;
  align-items: center;
}
.dl-collapse__panel {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
}
.dl-collapse__panel_no-data {
  cursor: default;
}
.dl-collapse__title {
  margin: 0;
}
.dl-collapse__title_secondary {
  color: var(--g-color-text-secondary);
}
.dl-collapse__title_size_s {
  font-family: var(--g-text-body-font-family);
  font-weight: var(--g-text-body-font-weight);
  font-size: var(--g-text-body-1-font-size);
  line-height: var(--g-text-body-1-line-height);
}
.dl-collapse__title_size_m {
  font-family: var(--g-text-body-font-family);
  font-weight: var(--g-text-body-font-weight);
  font-size: var(--g-text-body-2-font-size);
  line-height: var(--g-text-body-2-line-height);
}
.dl-collapse__title_size_l {
  font-family: var(--g-text-body-font-family);
  font-weight: var(--g-text-body-font-weight);
  font-size: var(--g-text-body-3-font-size);
  line-height: var(--g-text-body-3-line-height);
}
.dl-collapse__arrow-wrapper_position_left {
  margin-right: 8px;
}
.dl-collapse__arrow-wrapper_position_right {
  margin-left: 8px;
}
.dl-collapse__arrow-wrapper_secondary {
  color: var(--g-color-text-secondary);
}
.dl-collapse__arrow-wrapper_secondary .g-button__text {
  color: var(--g-color-text-secondary);
}
.dl-collapse__arrow-button .g-button__text {
  margin: 0 4px;
}
.dl-collapse__empty-state-title {
  font-family: var(--g-text-body-font-family);
  font-weight: var(--g-text-body-font-weight);
  font-size: var(--g-text-body-1-font-size);
  line-height: var(--g-text-body-1-line-height);
  font-weight: normal;
  opacity: 0.5;
}
.dl-collapse_collapsed .dl-collapse__content {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/Collapse/Collapse.scss","webpack://./node_modules/@gravity-ui/uikit/styles/mixins.scss"],"names":[],"mappings":"AAGI;EACI,oBAAA;EACA,mBAAA;AAFR;AAKI;EACI,oBAAA;EACA,mBAAA;EAEA,eAAA;AAJR;AAMQ;EACI,eAAA;AAJZ;AAQI;EACI,SAAA;AANR;AASI;EACI,oCAAA;AAPR;AAWQ;EC2IJ,2CAAA;EACA,2CAAA;EACA,yCAAA;EACA,6CAAA;ADnJJ;AASQ;EC8IJ,2CAAA;EACA,2CAAA;EACA,yCAAA;EACA,6CAAA;ADpJJ;AAOQ;ECiJJ,2CAAA;EACA,2CAAA;EACA,yCAAA;EACA,6CAAA;ADrJJ;AAOQ;EACI,iBAAA;AALZ;AAQQ;EACI,gBAAA;AANZ;AAUI;EACI,oCAAA;AARR;AASQ;EACI,oCAAA;AAPZ;AAYQ;EACI,aAAA;AAVZ;AAcI;ECuGA,2CAAA;EACA,2CAAA;EACA,yCAAA;EACA,6CAAA;EDxGI,mBAAA;EAEA,YAAA;AAVR;AAaI;EACI,aAAA;AAXR","sourcesContent":[".dl-collapse__header {\n  display: inline-flex;\n  align-items: center;\n}\n.dl-collapse__panel {\n  display: inline-flex;\n  align-items: center;\n  cursor: pointer;\n}\n.dl-collapse__panel_no-data {\n  cursor: default;\n}\n.dl-collapse__title {\n  margin: 0;\n}\n.dl-collapse__title_secondary {\n  color: var(--g-color-text-secondary);\n}\n.dl-collapse__title_size_s {\n  font-family: var(--g-text-body-font-family);\n  font-weight: var(--g-text-body-font-weight);\n  font-size: var(--g-text-body-1-font-size);\n  line-height: var(--g-text-body-1-line-height);\n}\n.dl-collapse__title_size_m {\n  font-family: var(--g-text-body-font-family);\n  font-weight: var(--g-text-body-font-weight);\n  font-size: var(--g-text-body-2-font-size);\n  line-height: var(--g-text-body-2-line-height);\n}\n.dl-collapse__title_size_l {\n  font-family: var(--g-text-body-font-family);\n  font-weight: var(--g-text-body-font-weight);\n  font-size: var(--g-text-body-3-font-size);\n  line-height: var(--g-text-body-3-line-height);\n}\n.dl-collapse__arrow-wrapper_position_left {\n  margin-right: 8px;\n}\n.dl-collapse__arrow-wrapper_position_right {\n  margin-left: 8px;\n}\n.dl-collapse__arrow-wrapper_secondary {\n  color: var(--g-color-text-secondary);\n}\n.dl-collapse__arrow-wrapper_secondary .g-button__text {\n  color: var(--g-color-text-secondary);\n}\n.dl-collapse__arrow-button .g-button__text {\n  margin: 0 4px;\n}\n.dl-collapse__empty-state-title {\n  font-family: var(--g-text-body-font-family);\n  font-weight: var(--g-text-body-font-weight);\n  font-size: var(--g-text-body-1-font-size);\n  line-height: var(--g-text-body-1-line-height);\n  font-weight: normal;\n  opacity: 0.5;\n}\n.dl-collapse_collapsed .dl-collapse__content {\n  display: none;\n}",null],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
